import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import OpportunityDetail from './OpportunityDetail';
import * as actions from '../../redux/actions';

// หน้าต่างแยกจริง (window.open จาก OpportunityList.js) แทนที่ popup modal — ไม่มี
// sidebar/navbar ครอบ (route นี้อยู่นอก layout Marketing() ตั้งใจ) เนื้อหาเป็น
// OpportunityDetail ตัวเดิมเป๊ะ pattern เดียวกับ ProjectPopupWindow.js
export default function OpportunityPopupWindow() {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.meGet());
  }, [dispatch]);

  const notifyOpener = (type, extra) => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ type, id, ...extra }, window.location.origin);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 3 }}>
      <OpportunityDetail
        propId={id}
        onClose={() => {
          notifyOpener('pop-in');
          window.close();
        }}
      />
    </Box>
  );
}
